module.exports = __webpack_public_path__ + "static/media/cr.b6d92c95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cr.svg
// module id = 91
// module chunks = 0